<template>
  <div class="h-svh text-gray-900">
    <Header />
    <transition-group
      name="notifications"
      tag="ul"
      class="absolute top-5 right-5 z-20 space-y-4 w-80"
    >
      <li v-for="notification in notifications" :key="notification">
        <Notification :notification="notification" />
      </li>
    </transition-group>

    <RouterView class="h-full" />
  </div>
</template>

<script setup>
import "chartjs-adapter-date-fns";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";

Chart.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend,
);

import { storeToRefs } from "pinia";
import Header from "@/components/Header.vue";
import Notification from "@/components/Notification.vue";
import useNotificationStore from "@/stores/notifications";

const notificationStore = useNotificationStore();

const { notifications } = storeToRefs(notificationStore);
</script>

<style>
.notifications-move, /* apply transition to moving elements */
.notifications-enter-active,
.notifications-leave-active {
  transition: all 0.5s ease;
}

.notifications-enter-from,
.notifications-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.notifications-leave-active {
  position: absolute;
}
</style>
